// extracted by mini-css-extract-plugin
export default {"title":"Oaa-z","warning":"Paa-z","sizeOptionsLegendText":"Qaa-z"};